<template>
    <div class="group-page-menu-actions">
        <div class="row group-page-menu-action"
             :class="{'group-page-menu-action_active': action.active}"
             :aria-label="action.label"
             :key="action.id"
             tabindex="0"
             @click.stop.prevent="onActionClick(action)"
             @keydown.enter="onActionClick(action)"
             v-for="action in actions"
        >
            <div class="col-xs-12 margin-5-top margin-5-bottom">
                <span
                        class="group-page-menu-action__icon text-center"
                        :class="action.iconType==='fa'?undefined:action.iconClass"
                >
                    <i v-if="action.iconType==='fa'"
                       :class="action.iconClass"
                       style="font-size: 29px;line-height: 36px;"
                    ></i>
                </span>
                <span class="group-page-menu-action__text">{{ action.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "GroupPageMenuActions",
        computed: {
            ...mapGetters('groupPage', {viewer_state: 'viewer_state'}),
            actions() {
                const actions = [
                    {
                        id: 'group-chats',
                        label: `Group Chats`,
                        iconClass: 'group_conversations',
                        actionType: 'router-link',
                        to: 'groupDetailPage-chats',
                        active: this.$route.name === 'groupDetailPage-chats'
                    },
                    {
                        id: 'talk-to-group',
                        label: `Chat with this Group`,
                        iconClass: 'talk_to_group',
                        actionType: 'event',
                        event: 'startChat',
                    },
                ];
                if (this.viewer_state.is_admin) {
                    actions.push({
                        id: 'settings',
                        label: `Group Settings`,
                        iconClass: 'settings',
                        actionType: 'event',
                        event: 'openSettings',
                    });
                }
                actions.push({
                    id: 'leave',
                    label: `Leave Group`,
                    iconClass: 'fa fa-sign-out',
                    iconType: 'fa',
                    actionType: 'event',
                    event: 'leaveGroup',
                });


                return actions;
            }
        },
        methods: {
            onActionClick(action) {
                if (action.actionType === 'router-link') {
                    this.$router.push({...this.$route, name: action.to});
                } else if (action.actionType === 'event') {
                    this.$emit(action.event);
                }
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";
  @import "../../styles/mixins";

  .group-page-menu-actions {
    margin-top: 10px;
    text-align: left;
    padding: 0 15px;

    background-color: $menu-blue;
    border-radius: 5px;
  }

  .group-page-menu-action {
    font-size: 20px;
    line-height: 20px;
    color: #ffffff;
    cursor: pointer;
    transition: background-color ease 0.05s;

    &_active {
      font-weight: bolder;
    }

    &:hover, &:active, &:focus-visible {
      background-color: #1872b5;
      border-radius: 5px;
    }

    $icon-size: 32px;

    &__icon {
      display: inline-block;
      @include mm-icons;
      background-position: center;
      background-repeat: no-repeat;
      background-size: $icon-size $icon-size;
      width: $icon-size+3px;
      height: $icon-size+3px;
      vertical-align: middle;
    }

    &__text {
      padding-left: 5px;
      vertical-align: middle;
      color: white;
      font-size: 16px;
      //width: 90%;
      display: inline-block;
      max-width: 80%;
      max-width: calc(100% - 55px);
    }
  }
</style>